/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";
import { useAuth } from "@/hooks/useAuth";

/**
 * useIsAdmin
 * Client-side helper that asks the server (via SECURITY DEFINER RPC is_admin())
 * whether the current authenticated user is an admin. This avoids leaking
 * any whitelist via public build-time env vars and keeps the server the
 * source of truth.
 */
export function useIsAdmin() {
  const { profile } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (!profile?.email) {
        if (!cancelled) {
          setIsAdmin(false);
          setLoading(false);
        }
        return;
      }
      setLoading(true);
      // RPC has no arguments; uses auth.uid() internally
      const { data, error } = await (supabase as any).rpc("is_admin");
      if (!cancelled) {
        if (error) {
          logger.warn("[useIsAdmin] RPC error", error);
          setIsAdmin(false);
        } else {
          setIsAdmin(!!data);
        }
        setLoading(false);
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [profile?.email]);

  return { isAdmin, loading };
}

export default useIsAdmin;
